import React from 'react';
import { MotifCheckbox } from '@ey-xd/motif-react';

export default (props) => {
  let rowsChecked = 0;
  let totalRows = 0;
  let noPublishableRows = true;
  let totalRowsPublishable = 0;
  let rowsCheckedPublishable = 0;

  props.api.forEachNodeAfterFilter((rowNode) => {
    if (rowNode.data) {
      totalRows++;
      if (rowNode.data.isPSQDataPublished) {
        rowsChecked++;
      }
      const eligible =
        !!rowNode.data.isPSQServiceScopeEnabled ||
        !!rowNode.data.isPSQDataPublished;
      if (eligible) {
        totalRowsPublishable++;
        noPublishableRows = false;
      }
      if (rowNode.data.isPSQDataPublished && eligible) {
        rowsCheckedPublishable++;
      }
    }
  });

  let headerCheckboxValue = false;
  let indeterminate = false;

  if (rowsChecked === 0) {
    headerCheckboxValue = false;
  } else if (totalRows === rowsChecked) {
    headerCheckboxValue = true;
  } else if (
    totalRowsPublishable === rowsCheckedPublishable &&
    totalRowsPublishable > 0
  ) {
    headerCheckboxValue = true;
  } else {
    headerCheckboxValue = false;
    indeterminate = true;
  }

  return (
    <div className="d-flex align-items-center justify-content-center mt-1">
      <MotifCheckbox
        type="checkbox"
        name="psq-header-checkbox"
        id="ag-psq-header-checkbox"
        checked={headerCheckboxValue}
        data-testid="chkPublishPsq"
        aria-label="Press Space to toggle PSQ selection"
        tabIndex="-1"
        onClick={() => props.onHeaderCheckboxChange(headerCheckboxValue)}
        indeterminate={indeterminate}
        disabled={noPublishableRows}
      ></MotifCheckbox>
      <div className="customHeaderLabel">{props.displayName}</div>
    </div>
  );
};
